import { FC } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { TProcessingStepProps } from './types';

export const ProcessingStep: FC<TProcessingStepProps> = ({ label, icon, isActive, isDone }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1.5,
				opacity: isActive || isDone ? 1 : 0.4,
				transition: 'opacity .4s ease',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: '28px',
					height: '28px',
					flexShrink: 0,
					color: isDone ? 'success.main' : isActive ? 'primary.main' : 'text.disabled',
					transition: 'color .4s ease',
					'& svg': { fontSize: '22px' },
					...(isActive && {
						animation: 'processingStepPulse 1.2s ease-in-out infinite',
						'@keyframes processingStepPulse': {
							'0%, 100%': { transform: 'scale(1)', opacity: 1 },
							'50%': { transform: 'scale(1.2)', opacity: 0.7 },
						},
					}),
					...(isDone && {
						animation: 'processingStepPop .3s ease',
						'@keyframes processingStepPop': {
							from: { transform: 'scale(.5)', opacity: 0 },
							to: { transform: 'scale(1)', opacity: 1 },
						},
					}),
				}}
			>
				{isDone ? <CheckCircle /> : icon}
			</Box>
			<Typography
				sx={{
					fontSize: '.875rem',
					fontWeight: isActive ? 'bold' : 'normal',
					color: isActive ? 'primary.main' : 'text.primary',
					transition: 'color .4s ease',
				}}
			>
				{label}
			</Typography>
			{isActive && <CircularProgress size={14} sx={{ ml: 'auto', flexShrink: 0 }} />}
		</Box>
	);
};
